module.exports = __webpack_public_path__ + "ua.c56fea2de9c9d6609ccd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ua.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ua.svg
// module chunks = styles